const memoizedGetFormsListString = () => {
  const cache = {};

  return (forms, donationUserId) => {
    if (donationUserId in cache) {
      return cache[donationUserId];
    }

    const formsListString = forms
      .filter((form) => form.responses.length)
      .filter((form) => form.responses.some((formResponse) => formResponse.user === donationUserId))
      .map((form) => form.name)
      .join(', ');

    cache[donationUserId] = formsListString;

    return formsListString;
  };
};

export const getFormsListString = memoizedGetFormsListString();
